






































import { computed, defineComponent, ref } from "@vue/composition-api";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { VaultFile, VaultFileUsageSubjectTypeEnum } from "@scrile/api-provider/dist/api/VaultsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { getMediaThumbnailUrl } from "@/lib/urlHelpers";
import config from "@/config";
import { AttachmentFile } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIconButton from "@/components/BaseIconButton";
import BaseInputFile from "@/components/BaseInputFile";
import VaultController from "@/components/VaultController";

export default defineComponent({
  name: "VaultModal",
  components: { BaseButton, BaseIconButton, BaseConfirm, BaseInputFile, VaultController },
  props: {
    show: { type: Boolean, default: false },
    maxFiles: { type: Number, default: Number.POSITIVE_INFINITY },
    recipient: { type: Object as () => UserPublicData },
    filterSubject: { type: Object as () => Subject<VaultFileUsageSubjectTypeEnum.MESSAGE_THREAD> },
    accept: { type: Array as () => string[], default: () => ["image", "video", "audio"] },
  },
  setup(props, { emit }) {
    const hasSelection = ref<boolean>(false);

    const { authUserStrict } = useAuthUser();
    const isMember = computed(() => authUserStrict.value && authUserStrict.value.role === config.userRegistrationRole);

    const addAttachment = async (files: File[]) => {
      emit("addAttachment", files);
      emit("close");
    };

    const addAttachmentFromVault = (files: VaultFile[]) => {
      const attachmentFiles: AttachmentFile[] = files.map(file => ({
        src: getMediaThumbnailUrl(file, file.urlPart),
        uid: file.uuid,
        type: file.metadata.contentType,
        publicAccess: false,
      }));
      emit("addAttachmentFromVault", attachmentFiles);
      emit("close");
    };

    return { addAttachment, addAttachmentFromVault, isMember, hasSelection };
  },
});
